import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/blue-tick.webm")